import { createInitialStates, createResourceNames, createSequenceTypes, getErrorData, getPayloadData } from '../helpers'
import { INITIAL_STATE_REDUCERS, RECORD_COUNT_HEADER } from '../constants'

const RESOURCES = [
  'paymentsApiBalancePost',
  'paymentsApiBalancePut',
  'paymentsApiCaptureByChargeIdGet',
  'paymentsApiCustomerByIdGet',
  'paymentsApiSubscriptionsGetByCustomer',
  'paymentsApiCustomersBySubscriptionPlanIdGet',
  'paymentsApiCustomersGet',
  'paymentsApiEventByIdGet',
  'paymentsApiEventsGet',
  'paymentsApiKeysGet',
  'paymentsApiLogByIdGet',
  'paymentsApiLogsGet',
  'paymentsApiMetricsAcceptanceGet',
  'paymentsApiMetricsAcceptancePaymentIntentsGet',
  'paymentsApiMetricsChargebackGet',
  'paymentsApiMetricsPaidGet',
  'paymentsApiPaginationGet',
  'paymentsApiPayoutsByIdGet',
  'paymentsApiPayoutsGet',
  'paymentsApiPlanByIdGet',
  'paymentsApiPlansGet',
  'paymentsApiReceiptByIdGet',
  'paymentsApiReceiptsGet',
  'paymentsApiReceiptTransactionsGet',
  'paymentsApiReportFilesPost',
  'paymentsApiTransfersByIdGet',
  'paymentsApiTransfersGet',
  'paymentsApiWebhooksGet',
  'paymentsDashboardCardsGet',
  'paymentsDashboardThisMonthGet',
  'paymentsApiSubscriptionsGet',
  'paymentsApiSubscriptionCancel',
  'paymentsApiSubscriptionPause',
  'paymentsApiSubscriptionResume',
  'paymentsApiSubscriptionGet',
  'paymentsApiSubscriptionChargesGet',
  'paymentsApiSubscriptionsByCustomerGet'
]
const R = createResourceNames(RESOURCES)
const TYPES = createSequenceTypes([
  'PAYMENTS_API_BALANCE_POST',
  'PAYMENTS_API_PAGINATION_POST',
  'PAYMENTS_API_BALANCE_PUT',
  'PAYMENTS_API_CAPTURE_BY_CHARGE_ID_GET',
  'PAYMENTS_API_CUSTOMER_BY_ID_GET',
  'PAYMENTS_API_CUSTOMERS_BY_SUBSCRIPTION_PLAN_ID_GET',
  'PAYMENTS_API_CUSTOMERS_GET',
  'PAYMENTS_API_EVENT_BY_ID_GET',
  'PAYMENTS_API_EVENTS_GET',
  'PAYMENTS_API_KEYS_GET',
  'PAYMENTS_API_LOG_BY_ID_GET',
  'PAYMENTS_API_LOGS_GET',
  'PAYMENTS_API_METRICS_ACCEPTANCE_GET',
  'PAYMENTS_API_METRICS_ACCEPTANCE_PAYMENT_INTENTS_GET',
  'PAYMENTS_API_METRICS_CHARGEBACK_GET',
  'PAYMENTS_API_METRICS_PAID_GET',
  'PAYMENTS_API_PAGINATION_GET',
  'PAYMENTS_API_PAYOUTS_BY_ID_GET',
  'PAYMENTS_API_PAYOUTS_GET',
  'PAYMENTS_API_PLAN_BY_ID_GET',
  'PAYMENTS_API_PLANS_GET',
  'PAYMENTS_API_RECEIPT_BY_ID_GET',
  'PAYMENTS_API_RECEIPT_TRANSACTIONS_GET',
  'PAYMENTS_API_RECEIPTS_GET',
  'PAYMENTS_API_REPORT_FILES_POST',
  'PAYMENTS_API_SIGNATURE_KEYS_GET',
  'PAYMENTS_API_TRANSFERS_BY_ID_GET',
  'PAYMENTS_API_TRANSFERS_GET',
  'PAYMENTS_API_WEBHOOKS_GET',
  'PAYMENTS_DASHBOARD_CARDS_GET',
  'PAYMENTS_DASHBOARD_THIS_MONTH_GET',
  'PAYMENTS_API_SUBSCRIPTIONS_GET',
  'PAYMENTS_API_SUBSCRIPTION_CANCEL',
  'PAYMENTS_API_SUBSCRIPTION_PAUSE',
  'PAYMENTS_API_SUBSCRIPTION_RESUME',
  'PAYMENTS_API_SUBSCRIPTION_GET',
  'PAYMENTS_API_SUBSCRIPTION_CHARGES_GET',
  'PAYMENTS_API_SUBSCRIPTIONS_BY_CUSTOMER_GET'
])
export const INITIAL_STATE = { ...createInitialStates(RESOURCES, INITIAL_STATE_REDUCERS) }

const reducers = {
  // PAYMENTS API BALANCE POST ·························································································
  [TYPES.PAYMENTS_API_BALANCE_POST_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiBalancePost]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_BALANCE_POST_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiBalancePost]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_BALANCE_POST_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiBalancePost]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_BALANCE_POST_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiBalancePost
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API BALANCE PUT ··························································································
  [TYPES.PAYMENTS_API_BALANCE_PUT_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiBalancePut]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_BALANCE_PUT_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiBalancePut]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_BALANCE_PUT_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiBalancePut]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_BALANCE_PUT_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiBalancePut
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API CAPTURE BY CHARGE ID GET .............................................................................
  [TYPES.PAYMENTS_API_CAPTURE_BY_CHARGE_ID_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiCaptureByChargeIdGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_CAPTURE_BY_CHARGE_ID_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiCaptureByChargeIdGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_CAPTURE_BY_CHARGE_ID_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiCaptureByChargeIdGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_CAPTURE_BY_CHARGE_ID_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiCaptureByChargeIdGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API CUSTOMER BY ID GET ...................................................................................
  [TYPES.PAYMENTS_API_CUSTOMER_BY_ID_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiCustomerByIdGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_CUSTOMER_BY_ID_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiCustomerByIdGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_CUSTOMER_BY_ID_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiCustomerByIdGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_CUSTOMER_BY_ID_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiCustomerByIdGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API CUSTOMERS GET ........................................................................................
  [TYPES.PAYMENTS_API_CUSTOMERS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiCustomersGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_CUSTOMERS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiCustomersGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_CUSTOMERS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiCustomersGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_CUSTOMERS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiCustomersGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API EVENT BY ID GET ......................................................................................
  [TYPES.PAYMENTS_API_EVENT_BY_ID_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiEventByIdGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_EVENT_BY_ID_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiEventByIdGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_EVENT_BY_ID_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiEventByIdGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_EVENT_BY_ID_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiEventByIdGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API EVENTS GET ···························································································
  [TYPES.PAYMENTS_API_EVENTS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiEventsGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_EVENTS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiEventsGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_EVENTS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiEventsGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_EVENTS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiEventsGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API KEYS GET ·····························································································
  [TYPES.PAYMENTS_API_KEYS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiKeysGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_KEYS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiKeysGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_KEYS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiKeysGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_KEYS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiKeysGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API LOG BY ID GET ........................................................................................
  [TYPES.PAYMENTS_API_LOG_BY_ID_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiLogByIdGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_LOG_BY_ID_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiLogByIdGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_LOG_BY_ID_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiLogByIdGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_LOG_BY_ID_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiLogByIdGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API LOGS GET ·····························································································
  [TYPES.PAYMENTS_API_LOGS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiLogsGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_LOGS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiLogsGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_LOGS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiLogsGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_LOGS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiLogsGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API METRICS ACCEPTANCE GET ···············································································
  [TYPES.PAYMENTS_API_METRICS_ACCEPTANCE_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiMetricsAcceptanceGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_METRICS_ACCEPTANCE_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiMetricsAcceptanceGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_METRICS_ACCEPTANCE_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiMetricsAcceptanceGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_METRICS_ACCEPTANCE_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiMetricsAcceptanceGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API METRICS ACCEPTANCE PAYMENT INTENTS GET ·······························································
  [TYPES.PAYMENTS_API_METRICS_ACCEPTANCE_PAYMENT_INTENTS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiMetricsAcceptancePaymentIntentsGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_METRICS_ACCEPTANCE_PAYMENT_INTENTS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiMetricsAcceptancePaymentIntentsGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_METRICS_ACCEPTANCE_PAYMENT_INTENTS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiMetricsAcceptancePaymentIntentsGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_METRICS_ACCEPTANCE_PAYMENT_INTENTS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiMetricsAcceptancePaymentIntentsGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API METRICS CHARGEBACK GET ···············································································
  [TYPES.PAYMENTS_API_METRICS_CHARGEBACK_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiMetricsChargebackGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_METRICS_CHARGEBACK_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiMetricsChargebackGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_METRICS_CHARGEBACK_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiMetricsChargebackGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_METRICS_CHARGEBACK_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiMetricsChargebackGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API METRICS PAID GET ·····················································································
  [TYPES.PAYMENTS_API_METRICS_PAID_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiMetricsPaidGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_METRICS_PAID_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiMetricsPaidGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_METRICS_PAID_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiMetricsPaidGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_METRICS_PAID_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiMetricsPaidGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  [TYPES.PAYMENTS_DASHBOARD_CARDS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsDashboardCardsGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_DASHBOARD_CARDS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsDashboardCardsGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_DASHBOARD_CARDS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsDashboardCardsGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_DASHBOARD_CARDS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsDashboardCardsGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  [TYPES.PAYMENTS_DASHBOARD_THIS_MONTH_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsDashboardThisMonthGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_DASHBOARD_THIS_MONTH_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsDashboardThisMonthGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_DASHBOARD_THIS_MONTH_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsDashboardThisMonthGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_DASHBOARD_THIS_MONTH_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsDashboardThisMonthGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API PAGINATION GET ·······················································································
  [TYPES.PAYMENTS_API_PAGINATION_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiPaginationGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_PAGINATION_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiPaginationGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_PAGINATION_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiPaginationGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_PAGINATION_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiPaginationGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API PAYOUTS GET ..........................................................................................
  [TYPES.PAYMENTS_API_PAYOUTS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiPayoutsGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_PAYOUTS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiPayoutsGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_PAYOUTS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiPayoutsGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_PAYOUTS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiPayoutsGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API PAYOUTS BY ID GET ....................................................................................
  [TYPES.PAYMENTS_API_PAYOUTS_BY_ID_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiPayoutsByIdGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_PAYOUTS_BY_ID_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiPayoutsByIdGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_PAYOUTS_BY_ID_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiPayoutsByIdGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_PAYOUTS_BY_ID_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiPayoutsByIdGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API PLAN BY ID GET .......................................................................................
  [TYPES.PAYMENTS_API_PLAN_BY_ID_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiPlanByIdGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_PLAN_BY_ID_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const DATA: any[] = getPayloadData(payload)
    return {
      ...state,
      [R.paymentsApiPlanByIdGet]: { data: DATA, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_PLAN_BY_ID_GET_FAILED]: (state: any, payload: any) => {
    const ERROR = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiPlanByIdGet]: { data: [], error: ERROR, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_PLAN_BY_ID_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiPlanByIdGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API PLANS GET ............................................................................................
  [TYPES.PAYMENTS_API_PLANS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiPlansGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_PLANS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiPlansGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_PLANS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiPlansGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_PLANS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiPlansGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API RECEIPTS GET ·························································································
  [TYPES.PAYMENTS_API_RECEIPTS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiReceiptsGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_RECEIPTS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiReceiptsGet]: { data, error: {}, isLoading: false, total: payload.headers[RECORD_COUNT_HEADER] }
    }
  },
  [TYPES.PAYMENTS_API_RECEIPTS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiReceiptsGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_RECEIPTS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiReceiptsByIdGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API RECEIPT BY ID GET ····················································································
  [TYPES.PAYMENTS_API_RECEIPT_BY_ID_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiReceiptByIdGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_RECEIPT_BY_ID_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiReceiptByIdGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_RECEIPT_BY_ID_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiReceiptByIdGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_RECEIPT_BY_ID_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiReceiptByIdGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API RECEIPT TRANSACTIONS GET ·············································································
  [TYPES.PAYMENTS_API_RECEIPT_TRANSACTIONS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiReceiptTransactionsGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_RECEIPT_TRANSACTIONS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiReceiptTransactionsGet]: {
        data,
        error: {},
        isLoading: false,
        total: payload.headers[RECORD_COUNT_HEADER]
      }
    }
  },
  [TYPES.PAYMENTS_API_RECEIPT_TRANSACTIONS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiReceiptTransactionsGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_RECEIPT_TRANSACTIONS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiReceiptTransactionsGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API REPORT FILES POST ····················································································
  [TYPES.PAYMENTS_API_REPORT_FILES_POST_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiReportFilesPost]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_REPORT_FILES_POST_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiReportFilesPost]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_REPORT_FILES_POST_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiReportFilesPost]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_REPORT_FILES_POST_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiReportFilesPost
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API TRANSFERS GET ·······················································································
  [TYPES.PAYMENTS_API_TRANSFERS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiTransfersGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_TRANSFERS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiTransfersGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_TRANSFERS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiTransfersGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_TRANSFERS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiTransfersGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API TRANSFERS BY ID GET ··················································································
  [TYPES.PAYMENTS_API_TRANSFERS_BY_ID_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiTransfersByIdGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_TRANSFERS_BY_ID_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiTransfersByIdGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_TRANSFERS_BY_ID_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiTransfersByIdGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_TRANSFERS_BY_ID_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiTransfersByIdGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API WEBHOOKS GET ·························································································
  [TYPES.PAYMENTS_API_WEBHOOKS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiWebhooksGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_WEBHOOKS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiWebhooksGet]: {
        data,
        error: {},
        isLoading: false,
        total: payload.headers[RECORD_COUNT_HEADER]
      }
    }
  },
  [TYPES.PAYMENTS_API_WEBHOOKS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiWebhooksGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_WEBHOOKS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiWebhooksGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API CUSTOMERS BY SUBSCRIPTION PLAN ID GET ································································
  [TYPES.PAYMENTS_API_CUSTOMERS_BY_SUBSCRIPTION_PLAN_ID_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiCustomersBySubscriptionPlanIdGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_CUSTOMERS_BY_SUBSCRIPTION_PLAN_ID_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const DATA: any[] = getPayloadData(payload)
    return {
      ...state,
      [R.paymentsApiCustomersBySubscriptionPlanIdGet]: { data: DATA, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_CUSTOMERS_BY_SUBSCRIPTION_PLAN_ID_GET_FAILED]: (state: any, payload: any) => {
    const ERROR = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiCustomersBySubscriptionPlanIdGet]: { data: [], error: ERROR, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_CUSTOMERS_BY_SUBSCRIPTION_PLAN_ID_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiCustomersBySubscriptionPlanIdGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // PAYMENTS API CUSTOMERS GET ·························································································
  [TYPES.PAYMENTS_API_CUSTOMERS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiCustomersGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_CUSTOMERS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = [{ ...payload.data }]
    return {
      ...state,
      [R.paymentsApiCustomersGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_CUSTOMERS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiCustomersGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_CUSTOMERS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiCustomersGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },
  [TYPES.PAYMENTS_API_SUBSCRIPTIONS_GET_REQUESTED]: (state: any) => ({
    ...state,
    [R.paymentsApiSubscriptionsGet]: { data: [], error: {}, isLoading: true }
  }),

  [TYPES.PAYMENTS_API_SUBSCRIPTIONS_GET_SUCCESSFUL]: (state: any, payload: any) => ({
    ...state,
    [R.paymentsApiSubscriptionsGet]: { data: payload.data, error: {}, isLoading: false }
  }),

  [TYPES.PAYMENTS_API_SUBSCRIPTIONS_GET_FAILED]: (state: any, payload: any) => ({
    ...state,
    [R.paymentsApiSubscriptionsGet]: { data: [], error: getErrorData(payload), isLoading: false }
  }),

  [TYPES.PAYMENTS_API_SUBSCRIPTIONS_GET_RESET]: (state: any) => ({
    ...state,
    [R.paymentsApiSubscriptionsGet]: { ...INITIAL_STATE[R.paymentsApiSubscriptionsGet] }
  }),

  // SUBSCRIPTIONS API CANCEL ..........................................................................................
  [TYPES.PAYMENTS_API_SUBSCRIPTION_CANCEL_REQUESTED]: (state: any) => ({
    ...state,
    [R.paymentsApiSubscriptionCancel]: { data: [], error: {}, isLoading: true }
  }),

  [TYPES.PAYMENTS_API_SUBSCRIPTION_CANCEL_SUCCESSFUL]: (state: any, payload: any) => ({
    ...state,
    [R.paymentsApiSubscriptionCancel]: { data: payload.data, error: {}, isLoading: false }
  }),

  [TYPES.PAYMENTS_API_SUBSCRIPTION_CANCEL_FAILED]: (state: any, payload: any) => ({
    ...state,
    [R.paymentsApiSubscriptionCancel]: { data: [], error: getErrorData(payload), isLoading: false }
  }),

  [TYPES.PAYMENTS_API_SUBSCRIPTION_CANCEL_RESET]: (state: any) => ({
    ...state,
    [R.paymentsApiSubscriptionCancel]: { ...INITIAL_STATE[R.paymentsApiSubscriptionCancel] }
  }),

  // SUBSCRIPTIONS API PAUSE ...........................................................................................
  [TYPES.PAYMENTS_API_SUBSCRIPTION_PAUSE_REQUESTED]: (state: any) => ({
    ...state,
    [R.paymentsApiSubscriptionPause]: { data: [], error: {}, isLoading: true }
  }),

  [TYPES.PAYMENTS_API_SUBSCRIPTION_PAUSE_SUCCESSFUL]: (state: any, payload: any) => ({
    ...state,
    [R.paymentsApiSubscriptionPause]: { data: payload.data, error: {}, isLoading: false }
  }),

  [TYPES.PAYMENTS_API_SUBSCRIPTION_PAUSE_FAILED]: (state: any, payload: any) => ({
    ...state,
    [R.paymentsApiSubscriptionPause]: { data: [], error: getErrorData(payload), isLoading: false }
  }),

  [TYPES.PAYMENTS_API_SUBSCRIPTION_PAUSE_RESET]: (state: any) => ({
    ...state,
    [R.paymentsApiSubscriptionPause]: { ...INITIAL_STATE[R.paymentsApiSubscriptionPause] }
  }),

  // SUBSCRIPTIONS API RESUME ..........................................................................................
  [TYPES.PAYMENTS_API_SUBSCRIPTION_RESUME_REQUESTED]: (state: any) => ({
    ...state,
    [R.paymentsApiSubscriptionResume]: { data: [], error: {}, isLoading: true }
  }),

  [TYPES.PAYMENTS_API_SUBSCRIPTION_RESUME_SUCCESSFUL]: (state: any, payload: any) => ({
    ...state,
    [R.paymentsApiSubscriptionResume]: { data: payload.data, error: {}, isLoading: false }
  }),

  [TYPES.PAYMENTS_API_SUBSCRIPTION_RESUME_FAILED]: (state: any, payload: any) => ({
    ...state,
    [R.paymentsApiSubscriptionResume]: { data: [], error: getErrorData(payload), isLoading: false }
  }),

  [TYPES.PAYMENTS_API_SUBSCRIPTION_RESUME_RESET]: (state: any) => ({
    ...state,
    [R.paymentsApiSubscriptionResume]: { ...INITIAL_STATE[R.paymentsApiSubscriptionResume] }
  }),

  // PAYMENTS API SUBSCRIPTION GET ........................................................................................
  [TYPES.PAYMENTS_API_SUBSCRIPTION_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiSubscriptionGet]: { data: null, error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_SUBSCRIPTION_GET_SUCCESSFUL]: (state: any, payload: any) => {
    return {
      ...state,
      [R.paymentsApiSubscriptionGet]: { data: payload.data, error: getErrorData(payload), isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_SUBSCRIPTION_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiSubscriptionGet]: { data: null, error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_SUBSCRIPTION_GET_RESET]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiSubscriptionGet]: { data: null, error: {}, isLoading: false }
    }
  },

  // PAYMENTS API SUBSCRIPTION CHARGES GET ........................................................................................
  [TYPES.PAYMENTS_API_SUBSCRIPTION_CHARGES_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiSubscriptionChargesGet]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_SUBSCRIPTION_CHARGES_GET_SUCCESSFUL]: (state: any, payload: any) => {
    return {
      ...state,
      [R.paymentsApiSubscriptionChargesGet]: { data: payload.data, error: getErrorData(payload), isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_SUBSCRIPTION_CHARGES_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiSubscriptionChargesGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_SUBSCRIPTION_CHARGES_GET_RESET]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiSubscriptionChargesGet]: { data: [], error: {}, isLoading: false }
    }
  },

  // PAYMENTS API SUBSCRIPTIONS BY CUSTOMER GET ........................................................................................
  [TYPES.PAYMENTS_API_SUBSCRIPTIONS_BY_CUSTOMER_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiSubscriptionsGetByCustomer]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_SUBSCRIPTIONS_BY_CUSTOMER_GET_SUCCESSFUL]: (state: any, payload: any) => {
    return {
      ...state,
      [R.paymentsApiSubscriptionsGetByCustomer]: { data: payload.data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_SUBSCRIPTIONS_BY_CUSTOMER_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiSubscriptionsGetByCustomer]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_SUBSCRIPTIONS_BY_CUSTOMER_GET_RESET]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiSubscriptionsGetByCustomer]: { data: [], error: {}, isLoading: false }
    }
  },

  // PAYMENTS API SUBSCRIPTIONS BY CUSTOMER GET ........................................................................................
  [TYPES.PAYMENTS_API_SUBSCRIPTIONS_BY_CUSTOMER_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.paymentsApiSubscriptionsGetByCustomer]: { data: [], error: {}, isLoading: true }
    }
  },
  [TYPES.PAYMENTS_API_SUBSCRIPTIONS_BY_CUSTOMER_GET_SUCCESSFUL]: (state: any, payload: any) => {
    return {
      ...state,
      [R.paymentsApiSubscriptionsGetByCustomer]: { data: payload.data, error: {}, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_SUBSCRIPTIONS_BY_CUSTOMER_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.paymentsApiSubscriptionsGetByCustomer]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.PAYMENTS_API_SUBSCRIPTIONS_BY_CUSTOMER_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.paymentsApiSubscriptionsGetByCustomer
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  }
}

export default reducers
